export const GoogleEventEnum = Object.freeze({
  register: 1,  // Event snippet for Complete Registration conversion page
  paywall: 2,   // Event snippet for Paywall View conversion page
  checkout: 3,  // Event snippet for Initiate Checkout conversion page
  purchase: 4,  // Event snippet for Purchase conversion page
})
